import { injectCpmsBoChargePointApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-charge-point.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoChargePointApi = injectCpmsBoChargePointApi(baseApi);

export const {
  useCpmsBoGetChargePointLogsQuery,
  useCpmsBoSetChargePointsLocationMutation,
  useCpmsBoSetChargePointsTariffMutation,
  useCpmsBoGetChargePointQuery,
  useCpmsBoCreateChargePointMutation,
  useCpmsBoUpdateChargePointMutation,
  useCpmsBoDeleteChargePointMutation,
  useCpmsBoGetChargePointsPaginatedQuery,
  useCpmsBoGetChargePointsInMaintenanceQuery,
  useCpmsBoRemoveChargePointsLocationMutation,
  useCpmsBoCreateChannelMutation,
  useCpmsBoUpdateChannelMutation,
  useCpmsBoDeleteChannelMutation,
  useCpmsBoCreatePhysicalSocketMutation,
  useCpmsBoUpdatePhysicalSocketMutation,
  useCpmsBoDeletePhysicalSocketMutation,
  useCpmsBoGetChannelQuery,
} = cpmsBoChargePointApi;
